import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import knownAbnormalityTypes from '../../constants/AbnormalityTypes';
import { setExcludedAbnormalityTypes } from '../../reducers/BuildRenderRequestSlice';

export const AbnormalityFilter = () => {
  const dispatch = useDispatch();
  const { excludedAbnormalityTypes } = useSelector((state: RootState) => state.buildRenderRequest);

  const onTypeChange = (type: string, checked: boolean) => {
    let newExcluded = excludedAbnormalityTypes.filter(c => c !== type);
    if (!checked) newExcluded = [...newExcluded, type];
    dispatch(setExcludedAbnormalityTypes(newExcluded));
  };

  const toggleSelectAll = (checked: boolean) => {
    dispatch(setExcludedAbnormalityTypes(checked ? [] : knownAbnormalityTypes));
  };

  return (
    <div className="abn-grid">
      {knownAbnormalityTypes.map(c => (
        <label key={c} className="abn-item">
          <input
            type="checkbox"
            checked={!excludedAbnormalityTypes.includes(c)}
            onChange={e => onTypeChange(c, e.target.checked)}
          />
          <span>{c.replace('_', ' ')}</span>
        </label>
      ))}
      <label className="abn-item abn-select-all">
        <input
          type="checkbox"
          checked={excludedAbnormalityTypes.length === 0}
          onChange={e => toggleSelectAll(e.target.checked)}
        />
        <span>Select All</span>
      </label>
    </div>
  );
};
